/**
 * @author Fernando Ruano
 * @file index.js
 * @description Confirm Modal Component
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { CloseCircleFilled, InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Modal, Button } from 'antd';

// Styles
import styles from './styles.module.css';

/**
 * Confirm Modal Component.
 * @return { Node } React Confirm Modal Component
 */
const ConfirmModal = ({
  mode,
  visibleConfirm,
  contentComponent,
  onCancel,
  onSubmit,
  onCancelText,
  onSubmitText
}) => {
  const { t: translate } = useTranslation();
  return (
    <Modal visible={visibleConfirm} title="" closable={false} footer={null}>
      <div className="text-center">
        {mode === 'confirm' ? (
          <InfoCircleOutlined
            style={{ color: 'var(--color-baxter-teal-medium)', fontSize: 88 }}
          />
        ) : (
          <CloseCircleFilled
            style={{ color: 'var(--color-baxter-teal-medium)', fontSize: 88 }}
          />
        )}
        <h2 className="mb-0 mt-4 text-2xl font-bold text-baxterGray">
          {translate('calendarMg.confirmInfo')}
        </h2>
        {contentComponent}
        <div className="w-full flex flex-row justify-center mt-6">
          <Button className={styles.cancelButtonConfirm} onClick={onCancel}>
            {translate(onCancelText)}
          </Button>
          <Button className={styles.okButtonConfirm} onClick={onSubmit}>
            {translate(onSubmitText)}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

/**
 * @name ConfirmModal.propTypes
 * @type { Object }
 */
ConfirmModal.propTypes = {
  mode: PropTypes.string,
  className: PropTypes.string,
  visibleConfirm: PropTypes.bool,
  contentComponent: PropTypes.element,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  onCancelText: PropTypes.string,
  onSubmitText: PropTypes.string
};

/**
 * Default props
 */
ConfirmModal.defaultProps = {
  mode: 'confirm',
  visibleConfirm: false,
  onCancelText: 'commons.cancel'
};

export default ConfirmModal;
